var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          attrs: {
            action: _vm.action,
            multiple: _vm.multiple,
            data: _vm.data,
            name: _vm.name,
            "show-file-list": _vm.showFileList,
            drag: _vm.drag,
            "list-type": _vm.listType,
            "auto-upload": _vm.autoUpload,
            "file-list": _vm.fileList,
            disabled: _vm.disabled,
            limit: _vm.limit,
            "on-success": _vm.handleAvatarSuccess,
            "before-upload": _vm.beforeAvatarUpload,
            "on-exceed": _vm.onExceed,
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
          },
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }